<template>
  <div class="footer used">ご利用ありがとうございました <br /></div>
</template>

<script>
export default {
  name: "FaceEndMessage",
};
</script>

<style lang="scss" scoped>
.footer.used {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #000000;
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
}
</style>
